// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2TSPr","savePackageButton":"ClientWallet_savePackageButton__2sr7X"};